import ContentfulLink from './contentful/ContentfulLink'
import { ContentfulExperimentConfig } from './ContentfulExperimentConfig'

interface ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]
}

class Link implements ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]

  constructor({ id, navigationPath, scrollToHash, experimentConfig }: ILink) {
    this.id = id
    this.navigationPath = navigationPath
    this.scrollToHash = scrollToHash
    this.experimentConfig = experimentConfig
    return {
      ...this,
    }
  }

  static fromContentful(contentfulLink: ContentfulLink) {
    return new Link({
      id: contentfulLink.id,
      navigationPath: ContentfulLink.getLinkPath(contentfulLink),
      scrollToHash: contentfulLink.scrollToHash,
      experimentConfig: contentfulLink.experimentConfig,
    })
  }
}

export default Link
